module.exports = __webpack_public_path__ + "img/title-2.42a437bd.png";